const customSelectors = {};
class customJS {
    constructor() {
        document.querySelectorAll('[data-week_number]').forEach(ele => {
            ele.setAttribute('data-week_number',Utility.getCurrentWeekNumber())
            let weekNumber=ele.getAttribute('data-week_number');
            let range=Utility.getDateRangeOfWeek(weekNumber).split(',');
            let startDate=moment(range[0]).format('MMM DD');
            let endDate=moment(range[1]).format('MMM DD, YYYY');
            ele.querySelector('[data-week_dates]').innerHTML=`${startDate} - ${endDate}`
            moment(window.globalVariables.server_time).format('MMM')
        });
        

        document.querySelectorAll('[data-redirect-upcomingorder]').forEach(ele => {
            ele.addEventListener('click', (e) => {
                e.target.closest('.modal.open').querySelector('.close-quickshop').click();
                document.querySelector('[data-tabcontent="#deliveryschedule"]').click();
            })
        });

        // Check The Store Subscription limit and manage get started button
        // this._checkStoreSubscriptionsLimit();
        if (window.location.href.includes('/account') || window.location.href.includes('/cart')) {
            this._fetchShopifyProducts();
        }
        // equalHeight for all product cards
        var productCardWrapper = document.querySelectorAll('.featured-collection-slider .card-product h6.card-title');
        if (productCardWrapper.length > 0)  { this.equalHeightFunction(productCardWrapper); }
    }

    async _checkStoreSubscriptionsLimit(){
        var limit=window.RcustomerDetails.store_subscriptions_limit || 0;
        var currentSubscriptions = await this._checkStoreSubscriptions();
        document.querySelectorAll('[data-start-flow]').forEach((ele)=>{
            if (currentSubscriptions > limit) {
                ele.setAttribute('data-start-flow',false);
            }else{
                ele.setAttribute('data-start-flow',true);
            }
        });
    }

    /**
     * 
     * @returns Store Active Subscription count from recharge
     */
    async _checkStoreSubscriptions(){
        const response = await fetch('https://e2mkitchen.com/apps/frontend/subscription-count',
            {
            method:'POST',
            headers: {'Content-Type': 'application/json','X-shop': window.RcustomerDetails.url}
            }
        );

        if (response.ok) {
            const data = await response.json();
            return await parseInt(data.data.subscription_count);
        }else{
            Utility.notification('Something went wrong','','error');
        }
    }

    /**
     * 
     * @returns Fetch Products from shopify for inventory management
    */
    async _fetchShopifyProducts(){
        const response = await fetch('https://e2mkitchen.com/apps/frontend/product-list',
        {
            method:'POST',
            headers: {
                'Content-Type': 'application/json',
                'Cache-Control':'no-cache, no-store, must-revalidate',
                'X-shop': `${window.RcustomerDetails.url}`
            }
            }
        );

        if (response.ok) {
            const data = await response.json();
            window.globalVariables.availableProducts = data.data;
            return await data;
        }else{
            Rollbar.error(`Custom => Error in product-list api`);
            console.log('Error in fetching products data from shopify')
        }
    }
 

    equalHeightFunction(arrayOfEle) {
        if(arrayOfEle.length > 0) {
            var divHeight = 0 ;
            arrayOfEle.forEach(item => { if(item.offsetHeight > divHeight) { divHeight = item.offsetHeight; } })
            arrayOfEle.forEach(item => { item.style.height = divHeight+'px'; })
        }
    }
}

typeof customJS !== 'undefined' && new customJS();
